import { render } from "./EditDocsAccount.vue?vue&type=template&id=5f4cca62&scoped=true"
import script from "./EditDocsAccount.vue?vue&type=script&lang=js"
export * from "./EditDocsAccount.vue?vue&type=script&lang=js"

import "./EditDocsAccount.vue?vue&type=style&index=0&id=5f4cca62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4cca62"]])

export default __exports__